module.exports = __webpack_public_path__ + "img/52114149_L.9857d701.png";